import CloseIcon from '@mui/icons-material/Close';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import {
  IconButton,
  InputAdornment,
  TextField as MUITextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useCallback} from 'react';

const FilterTextField = ({
  value: valueProp,
  onChange,
  clearable = true,
  InputProps,
  placeholder = 'Filter',
  ...props
}) => {
  const handleOnChange = useCallback(
    event => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleOnClear = () => {
    onChange('');
  };

  return (
    <MUITextField
      size="small"
      value={valueProp}
      onChange={handleOnChange}
      placeholder={placeholder}
      sx={{backgroundColor: 'background.paper'}}
      {...props}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <FilterAltOutlinedIcon />
            </InputAdornment>
          ),
          endAdornment: valueProp && clearable && (
            <InputAdornment position="end">
              <IconButton onClick={handleOnClear}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ),
          ...InputProps,
        },
      }}
    />
  );
};

FilterTextField.propTypes = {
  clearable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  InputProps: PropTypes.object,
  placeholder: PropTypes.string,
};

export default FilterTextField;
